import { cn } from "@quortex/front-common"
import type { FC, PropsWithChildren } from "react"

const colorToIdentifierCls = {
  pink: "text-pink-500",
  purple: "text-purple-600",
  teal: "text-teal-600"
} as const

interface Props extends PropsWithChildren {
  color: "teal" | "pink" | "purple"
  className?: string
}

const Identifier: FC<Props> = ({ color, children, className }) => (
  <span
    className={cn(
      "max-w-full overflow-hidden text-ellipsis font-medium font-monospace text-sm",
      colorToIdentifierCls[color],
      className
    )}
  >
    {children}
  </span>
)

export default Identifier
